/*
  Linked add-ons: a lamp added from a tent page (snippets/product-addons.liquid) is saved with the
  hidden line property "_addon_for" = the tent's product id. A linked add-on can't stay in the cart
  without its tent, so whenever the cart changes (and on page load) any linked line whose tent is no
  longer in the cart is removed and the cart UI (page or drawer) is re-rendered in place.
  Lamps added from their own product page have no "_addon_for" and are never touched.
*/
(function () {
	const PROPERTY = '_addon_for';
	let running = false;
	let queued = false;

	function cartUi() {
		// On /cart the main cart is rendered; elsewhere the drawer. Both are CartItems subclasses (cart.js).
		return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
	}

	function orphanedAddons(cart) {
		const productIds = new Set(cart.items.map((item) => String(item.product_id)));
		return cart.items.filter((item) => {
			const parent = item.properties && item.properties[PROPERTY];
			return parent && !productIds.has(String(parent));
		});
	}

	function render(ui, state, sections) {
		const empty = state.item_count === 0;
		ui.classList.toggle('is-empty', empty);
		const drawer = document.querySelector('cart-drawer');
		const footer = document.getElementById('main-cart-footer');
		if (drawer) drawer.classList.toggle('is-empty', empty);
		if (footer) footer.classList.toggle('is-empty', empty);

		sections.forEach((section) => {
			const html = state.sections && state.sections[section.section];
			const host = document.getElementById(section.id);
			if (!html || !host) return;
			const target = host.querySelector(section.selector) || host;
			target.innerHTML = ui.getSectionInnerHTML(html, section.selector);
		});
	}

	async function sync() {
		if (running) {
			queued = true;
			return;
		}
		running = true;
		try {
			const cart = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
			const orphans = orphanedAddons(cart);
			if (!orphans.length) return;

			const updates = {};
			orphans.forEach((item) => (updates[item.key] = 0));
			const ui = cartUi();
			const sections = ui && typeof ui.getSectionsToRender === 'function' ? ui.getSectionsToRender() : [];

			const state = await fetch(`${window.routes.cart_update_url}.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({
					updates,
					sections: sections.map((section) => section.section),
					sections_url: window.location.pathname,
				}),
			}).then((r) => r.json());

			if (ui && state && !state.status) render(ui, state, sections);
		} catch (error) {
			console.error('Linked add-ons sync failed', error);
		} finally {
			running = false;
			if (queued) {
				queued = false;
				sync();
			}
		}
	}

	function cartHasItems() {
		const count = document.querySelector('#cart-icon-bubble .cart-count-bubble, .cart-count-bubble');
		return count ? parseInt(count.textContent, 10) > 0 : true;
	}

	// Shared with assets/tt-cart-suggest.js, which adds items from the cart and re-renders it the same way.
	window.ttCartAddons = { cartUi, render, sync };

	// After every quantity change / removal made in the cart page or drawer.
	if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
		subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			if (event && event.source === 'cart-items') sync();
		});
	}

	// On load, catch linked add-ons left without their tent (e.g. lamp added but tent never added).
	const start = () => {
		if (cartHasItems()) sync();
	};
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
	else start();
})();
